'use strict';
import { j as n } from "../../external/react/jsx-runtime.js";
import i from "../../external/classnames/index.js";
import u from "./badge.module.scss.js";
const g = ({
  className: t,
  as: e,
  text: r,
  variant: s = "default",
  size: o = "regular",
  rounded: a = !0,
  children: d,
  ...l
}) => {
  const m = e || "div";
  return /* @__PURE__ */ n.jsxs(
    m,
    {
      className: i(
        u.badge,
        {
          "rounded-full": a,
          "rounded-lg": !a
        },
        t
      ),
      "data-size": o,
      "data-variant": s,
      ...l,
      children: [
        r,
        d
      ]
    }
  );
};
export {
  g as default
};
